<template>
  <div class="videoPlayer">
    <div class="header" v-if="type == 'video'">
      <video id="playVideo" class="playVideo" :src="videoSrc" controls="controls"
        controlslist="nodownload noremoteplayback noplaybackrate" webkit-playsinline="true" playsinline="true"
        x-webkit-airplay="true" x5-playsinline="true" disablePictureInPicture x5-video-player-type="h5"
        x5-video-player-fullscreen="false" x5-video-orientation="portrait"></video>
      <div class="videoMask" v-if="videoMaskShow">
        <i v-if="videoSrc || loading" @click="startPlayVideo"></i>
        <div class="videoMaskText" v-if="!loading && !videoSrc">资源正在制作中，敬请期待</div>
      </div>
    </div>
    <AudioPlay v-if="type == 'audio'"></AudioPlay>
    <AnswerPlay v-if="type == 'answer'"></AnswerPlay>
    <div class="vTitle" v-if="type != 'answer'">
      <i></i>
      <span>{{ $route.query.name }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import '../unitList/index.scss'
import { getResourceContent } from "@/axios/bookUnit";
import AudioPlay from './components/AudioPlayer.vue';
import AnswerPlay from './components/AnswerPlayer.vue';


export default {
  components: { AudioPlay, AnswerPlay },
  data() {
    return {
      videoMaskShow: true,
      videoSrc: "",
      _video: null,
      showTime: 0,
      timer: null,
      loading: false,
      trackData: {
        pageId: 10002,
        pageName: '资源播放页面',
        resourceName: decodeURIComponent(this.$route.query.resourceName),
      },
      type: this.$route.query.type
    };
  },
  computed: {
    ...mapState({
      unionId: state => state.auth.unionId
    })
  },
  created() {
    ktbj.setUnionId(this.unionId)
    const { type } = this.$route.query;
    if (type == 'video') {
      this.getVideoContent()
    }
  },
  mounted() {
    this.reportPageExpose()
  },
  beforeDestroy() {
    this.destroyTimer()
    if (this.showTime) {
      ktbj.track('PAGE_EXIT', { ...this.trackData, duration: Date.now() - this.showTime });
    }
  },
  methods: {
    reportPageExpose() {
      this.showTime = Date.now()
      ktbj.track('PAGE_EXPOSE', this.trackData);
      this.reportPageView();
    },
    // 每隔10s上报一次PAGE_VIEW事件，使用setTimeout
    reportPageView() {
      this.destroyTimer()
      this.timer = setTimeout(() => {
        const now = Date.now()
        ktbj.track('PAGE_VIEW', { ...this.trackData, duration: now - this.showTime });
        this.showTime = now
        this.reportPageView();
      }, 10000);
    },
    destroyTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
    },
    createUuid: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    startPlayVideo() {
      this.videoMaskShow = false;
      this.playVideo.play();
    },
    getVideoContent() {
      this.loading = true;
      const filecode = decodeURIComponent(this.$route.query.videoId);
      getResourceContent({
        url: 'https://resource.youxuepai.com/ures/svc/famouseCource/getUrlByCodeForOnline',
        params: {
          open: 1,
          ratio: 720,
          type: 'hls',
          filecode: filecode,
          rd: 38,
          version: '导购版',
          userId: this.createUuid()
        }
      }).then((res) => {
        this._video = document.getElementById('playVideo');
        this.videoSrc = res.value || '';
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    startPlayVideo: function () {
      if (this.videoSrc == '') {
        vant.Toast('视频资源未就绪\n请稍候点击播放');
        return;
      }
      this.videoMaskShow = false;
      this.playVideo();
    },
    playVideo: function () {
      this._video.play();
    },

  },
};
</script>

<style lang="scss">
.videoMaskText {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
}

/* ========== 普通模式 ========== */
/* 隐藏音量按钮 + 音量滑块 */
.playVideo::-webkit-media-controls-mute-button,
.playVideo::-webkit-media-controls-volume-slider-container {
  display: none !important;
}

/* 隐藏倍速按钮（CSS兜底，配合controlslist） */
.playVideo::-webkit-media-controls-playback-rate-button {
  display: none !important;
}

/* 隐藏右上角三个点（更多选项） */
.playVideo::-webkit-media-controls-overflow-button {
  display: none !important;
}

/* ========== 全屏模式（必加，否则全屏会重新显示） ========== */
.playVideo:fullscreen::-webkit-media-controls-mute-button,
.playVideo:fullscreen::-webkit-media-controls-volume-slider-container,
.playVideo:fullscreen::-webkit-media-controls-playback-rate-button,
.playVideo:fullscreen::-webkit-media-controls-overflow-button,
/* 旧版webkit前缀兼容 */
.playVideo:-webkit-full-screen::-webkit-media-controls-mute-button,
.playVideo:-webkit-full-screen::-webkit-media-controls-volume-slider-container,
.playVideo:-webkit-full-screen::-webkit-media-controls-playback-rate-button,
.playVideo:-webkit-full-screen::-webkit-media-controls-overflow-button {
  display: none !important;
}

/* ========== 微信X5内核专属兼容 ========== */
.playVideo::-webkit-media-controls-panel .mute-button,
.playVideo::-webkit-media-controls-panel .playback-rate-button,
.playVideo::-webkit-media-controls-panel .overflow-button,
.playVideo:fullscreen::-webkit-media-controls-panel .mute-button,
.playVideo:fullscreen::-webkit-media-controls-panel .playback-rate-button,
.playVideo:fullscreen::-webkit-media-controls-panel .overflow-button {
  display: none !important;
}
</style>
